module.exports = __webpack_public_path__ + "img/Number=55.bdaafc31.png";